<template>
  <el-config-provider :locale="elementLocale">
    <router-view />
  </el-config-provider>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useHead } from '@vueuse/head'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import enUs from 'element-plus/es/locale/lang/en'

export default {
  name: 'App',
  components: { ElConfigProvider },
  setup() {
    const { t, locale } = useI18n()

    const elementLocale = computed(() =>
      locale.value === 'zh-CN' ? zhCn : enUs
    )

    useHead(computed(() => ({
      title: t('seo.title'),
      meta: [
        { name: 'description', content: t('seo.description') },
        { name: 'keywords', content: t('seo.keywords') },
      ],
    })))

    return { elementLocale }
  }
}
</script>

<style>
#app {
  width: 100vw;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* 仅对图片禁用拖拽/选中，不影响正文复制 */
#app img {
  -webkit-user-drag: none;
  user-select: none;
}
</style>
